import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { InfoHeader, InfoSubHeader, NoConnectionWrapper, NetworkIconWrapper } from './NoConnection/NoConnection.style';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';

export const NoConnection = observer(
    'NoConnection',
    (): JSX.Element => (
        <NoConnectionWrapper data-test='no-internet-page-container'>
            <NetworkIconWrapper />
            <InfoHeader data-test='no-internet-page-header'>
                <I18n
                    langKey='layouts.page-no-connection.header'
                    defaultText='There is no internet'
                />
            </InfoHeader>
            <InfoSubHeader data-test='no-internet-page-info'>
                <I18n
                    langKey='layouts.page-no-connection.sub-header'
                    defaultText='Please check your connection and try again.'
                />
            </InfoSubHeader>
        </NoConnectionWrapper>
    )
);
